<ng-template #content>
    <span class="link__inner">

        <span class="link__icon" *ngIf="icon">
            <shared-icon class="link__icon-obj" [icon]="icon"></shared-icon>
        </span>

        <span class="link__bd" [ngClass]="{'-mobile-hidden': mobile}">
            <span class="link__label" *ngIf="label">
                {{label}}
            </span>
            <span class="link__content">
                <ng-content></ng-content>
            </span>
        </span>
    </span>
</ng-template>

<ng-template #button>
    <button class="link -type-button{{size ? ' -size-'+size : ''}}" type="button" (click)="btnClick($event)"
        [disabled]="disabled" [title]="title" [attr.role]="role"
        [ngClass]="{'is-disabled': disabled, '-emphasis': emphasis, '-inverted': inverted}">
        <ng-container *ngTemplateOutlet="content"></ng-container>
    </button>
</ng-template>

<ng-template #link>
    <a class="link -type-link{{size ? ' -size-'+size : ''}}" [routerLink]="routerLink" [title]="title"
        [ngClass]="{'is-disabled': disabled, '-emphasis': emphasis, '-inverted': inverted}">
        <ng-container *ngTemplateOutlet="content"></ng-container>
    </a>
</ng-template>

<ng-container *ngTemplateOutlet="routerLink ? link : button"></ng-container>